import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";

import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";

import PageTitle from "../../commons/components/PageTitle";
import Modal from "../../commons/components/Modal";
import InputErrorMsgWrapper from "../../commons/components/input/InputErrorWrap";
import { ROUTES } from "../../commons/constants/routes/routes";

class MemberCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWarningShow: false,
      validationErrors: {},
      userId: "",
      email: "",
      isIdChecked: false,
      idAvailable: false,
      idCheckMessage: "",
      isEmailChecked: false,
      emailAvailable: false,
      emailCheckMessage: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleIdCheck = this.handleIdCheck.bind(this);
    this.handleEmailCheck = this.handleEmailCheck.bind(this);
  }

  validateForm(data) {
    const { isIdChecked, idAvailable, isEmailChecked, emailAvailable } = this.state;
    const validationErrors = {};

    if (!data.get("userId")) {
      validationErrors.userId = "아이디를 입력해주세요.";
    } else if (!isIdChecked) {
      validationErrors.userId = "아이디 중복확인을 해주세요.";
    } else if (!idAvailable) {
      validationErrors.userId = "이미 사용 중인 아이디입니다.";
    }
    if (!data.get("user_name")) {
      validationErrors.user_name = "이름을 입력해주세요.";
    }
    if (!data.get("phone")) {
      validationErrors.phone = "연락처를 입력해주세요.";
    }
    if (!data.get("email")) {
      validationErrors.email = "이메일을 입력해주세요.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.get("email"))) {
      validationErrors.email = "올바른 이메일 형식이 아닙니다.";
    } else if (!isEmailChecked) {
      validationErrors.email = "이메일 중복확인을 해주세요.";
    } else if (!emailAvailable) {
      validationErrors.email = "이미 사용 중인 이메일입니다.";
    }
    if (!data.get("password")) {
      validationErrors.password = "패스워드를 입력해주세요.";
    }
    if (data.get("password") !== data.get("password_confirm")) {
      validationErrors.password_confirm = "패스워드가 일치하지 않습니다.";
    }

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleIdCheck() {
    const { userId } = this.state;
    if (!userId) {
      this.setState({ validationErrors: { ...this.state.validationErrors, userId: "아이디를 입력해주세요." } });
      return;
    }
    try {
      const res = await axios.get(`/api/account/id-check/${userId}`);
      const available = !res.data?.result;
      this.setState({
        isIdChecked: true,
        idAvailable: available,
        idCheckMessage: available ? "사용 가능한 아이디입니다." : "이미 사용 중인 아이디입니다.",
        validationErrors: { ...this.state.validationErrors, userId: undefined },
      });
    } catch (e) {
      console.log(e);
    }
  }

  async handleEmailCheck() {
    const { email } = this.state;
    if (!email) {
      this.setState({ validationErrors: { ...this.state.validationErrors, email: "이메일을 입력해주세요." } });
      return;
    }
    try {
      const res = await axios.get(`/api/account/email-check/${encodeURIComponent(email)}`);
      const available = !res.data?.result;
      this.setState({
        isEmailChecked: true,
        emailAvailable: available,
        emailCheckMessage: available ? "사용 가능한 이메일입니다." : "이미 사용 중인 이메일입니다.",
        validationErrors: { ...this.state.validationErrors, email: undefined },
      });
    } catch (e) {
      console.log(e);
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);

    if (!this.validateForm(data)) return;

    const item = {
      userId: data.get("userId"),
      userName: data.get("user_name"),
      userType: "USR_P",
      password: data.get("password"),
      mobileCarrier: "",
      phone: data.get("phone"),
      email: data.get("email"),
      enabled: true,
      authorities: ["ROLE_USR"],
      user: {
        nickName: data.get("user_name"),
      },
    };

    const result = await CS.create("/api/account", item);
    if (result.isSuccess) {
      this.props.history.push(ROUTES.MEMBER.MAIN);
    }
  }

  closeModal = () => {
    this.setState({ isWarningShow: false });
  };

  render() {
    const {
      validationErrors,
      userId, email,
      isIdChecked, idAvailable, idCheckMessage,
      isEmailChecked, emailAvailable, emailCheckMessage,
    } = this.state;

    return (
      <>
        <PageTitle title="회원 관리" location="회원 등록" />
        <FormWrapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead required>아이디</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.userId}
                  message={validationErrors.userId}
                >
                  <input
                    type="text"
                    name="userId"
                    className="comm-inp"
                    placeholder="아이디를 입력하세요"
                    value={userId}
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.userId;
                      this.setState({
                        userId: e.target.value,
                        isIdChecked: false,
                        idAvailable: false,
                        idCheckMessage: "",
                        validationErrors,
                      });
                    }}
                  />
                </InputErrorMsgWrapper>
                <CheckButton type="button" onClick={this.handleIdCheck}>
                  중복확인
                </CheckButton>
                {idCheckMessage && (
                  <CheckMessage available={idAvailable}>{idCheckMessage}</CheckMessage>
                )}
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>이름</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.user_name}
                  message={validationErrors.user_name}
                >
                  <input
                    type="text"
                    name="user_name"
                    className="comm-inp"
                    placeholder="이름을 입력하세요"
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.user_name;
                      this.setState({ validationErrors });
                      VS.characterCheck(e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>연락처</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.phone}
                  message={validationErrors.phone}
                >
                  <input
                    type="text"
                    name="phone"
                    className="comm-inp"
                    placeholder="연락처를 입력하세요"
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.phone;
                      this.setState({ validationErrors });
                      VS.onInput("phone", e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>이메일</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.email}
                  message={validationErrors.email}
                >
                  <input
                    type="text"
                    name="email"
                    className="comm-inp"
                    placeholder="이메일을 입력하세요"
                    value={email}
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.email;
                      this.setState({
                        email: e.target.value,
                        isEmailChecked: false,
                        emailAvailable: false,
                        emailCheckMessage: "",
                        validationErrors,
                      });
                    }}
                  />
                </InputErrorMsgWrapper>
                <CheckButton type="button" onClick={this.handleEmailCheck}>
                  중복확인
                </CheckButton>
                {emailCheckMessage && (
                  <CheckMessage available={emailAvailable}>{emailCheckMessage}</CheckMessage>
                )}
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>패스워드</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.password}
                  message={validationErrors.password}
                >
                  <input
                    type="password"
                    name="password"
                    className="comm-inp"
                    placeholder="패스워드를 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.password;
                      delete validationErrors.password_confirm;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required>패스워드 확인</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.password_confirm}
                  message={validationErrors.password_confirm}
                >
                  <input
                    type="password"
                    name="password_confirm"
                    className="comm-inp"
                    placeholder="패스워드를 다시 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.password_confirm;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>
          </FormContainer>

          <BtnGroup>
            <button
              type="button"
              onClick={() => this.props.history.push(ROUTES.MEMBER.MAIN)}
            >
              취소
            </button>
            <button type="submit">저장</button>
          </BtnGroup>
        </FormWrapper>

        {this.state.isWarningShow && (
          <Modal
            icon={true}
            title="알림"
            text="저장 중 오류가 발생했습니다."
            btnGroup={false}
            closeModal={this.closeModal}
          />
        )}
      </>
    );
  }
}

const FormWrapper = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
`;
const FormHead = styled.p`
  width: 140px;
  display: inline-block;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  ${({ required }) =>
    required &&
    `&::after {
      content: " *";
      color: #FF5353;
    }`}
`;
const FormBody = styled.div`
  display: inline-block;
  input,
  select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 436px;
  }
`;
const CheckButton = styled.button`
  display: inline-block;
  margin-left: 8px;
  font-size: 13px;
  padding: 0 14px;
  height: 36px;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  color: var(--grey-900);
  background-color: var(--primary-500);
  border: 1px solid var(--primary-500);
  vertical-align: middle;
  &:hover {
    background-color: var(--primary-600);
  }
`;
const CheckMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: ${({ available }) => (available ? "#1ab245" : "#ff5353")};
`;
const BtnGroup = styled.div`
  max-width: 1176px;
  width: 100%;
  text-align: right;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:last-child {
      margin-left: 12px;
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
    }
  }
`;

export default MemberCreate;
